<template>
  <login-wrapper>
    <detail-wrapper chamber="house"></detail-wrapper>
  </login-wrapper>
</template>

<script>
import { DetailWrapper } from '@/components'
import { LoginWrapper } from '@/components/common'

const name = 'house'

const components = {
  DetailWrapper,
  LoginWrapper
}

export default {
  name,
  components,
  metaInfo: {
    title: '2020 House Forecast'
  }
}
</script>
